import React, { useRef, useState ,useEffect} from "react";
import "../../assets/css/about.css";
import { SiEthiopianairlines } from "react-icons/si";

import { useTranslation } from "react-i18next";
import introImage from "../../assets/image/viande7.webp";
import passionImage from "../../assets/image/table11.webp";
import qualityImage from "../../assets/image/table7.webp";
import galleryImage1 from "../../assets/image/table5.webp";
import galleryImage2 from "../../assets/image/galerie2.webp";
import galleryImage3 from "../../assets/image/galerie3.webp";
import galleryImage4 from "../../assets/image/table4.webp";
// Importez d'autres images de votre galerie
import galleryImage5 from "../../assets/image/galerie5.webp";
import galleryImage6 from "../../assets/image/galerie6.webp";
import galleryImage7 from "../../assets/image/table2.webp";
import galleryImage8 from "../../assets/image/table6.webp";
import galleryImage9 from "../../assets/image/table9.webp";
import galleryImage10 from "../../assets/image/table10.webp";
import galleryImage11 from "../../assets/image/table14.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronLeft,
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

export default function Apropos() {
    const { t } = useTranslation("apropos");
    const galleryRef = useRef(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const aboutSectionRef = useRef(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const galleryImages = [
        galleryImage3,
        galleryImage1,
        galleryImage2,
        galleryImage4,
        galleryImage5,
        galleryImage6,
        galleryImage7,
        galleryImage8,
        galleryImage9,
        galleryImage10,
        galleryImage11,
        // Ajoutez toutes vos images de galerie ici
    ];

    const nextImage = () => {
        setCurrentImageIndex(
            (prevIndex) => (prevIndex + 1) % galleryImages.length
        );
        if (galleryRef.current) {
            galleryRef.current.scrollTo({
                left: (currentImageIndex + 1) * galleryRef.current.offsetWidth,
                behavior: "smooth",
            });
        }
    };

    const prevImage = () => {
        setCurrentImageIndex(
            (prevIndex) =>
                (prevIndex - 1 + galleryImages.length) % galleryImages.length
        );
        if (galleryRef.current) {
            galleryRef.current.scrollTo({
                left: (currentImageIndex - 1) * galleryRef.current.offsetWidth,
                behavior: "smooth",
            });
        }
    };

    const handleThumbnailClick = (index) => {
        setCurrentImageIndex(index);
        if (galleryRef.current) {
            galleryRef.current.scrollTo({
                left: index * galleryRef.current.offsetWidth,
                behavior: "smooth",
            });
        }
    };
useEffect(() => {
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setIsLoaded(true);
                    observer.unobserve(aboutSectionRef.current); // Une seule activation suffit
                }
            });
        },
        {
            root: null, // viewport
            threshold: 0.2, // Seuil de visibilité (20% de la section visible)
        }
    );

    if (aboutSectionRef.current) {
        observer.observe(aboutSectionRef.current);
    }

    return () => {
        if (aboutSectionRef.current) {
            observer.unobserve(aboutSectionRef.current);
        }
    };
}, []);

    return (
        <section id="Apropos" ref={aboutSectionRef}>
            <div>
                <div
                    className={`about-section-block ${
                        isLoaded ? "loaded" : ""
                    }`}
                >
                    <div className="decoration about-block-title">
                        <SiEthiopianairlines className="deco1" />
                        <SiEthiopianairlines className="deco" />
                    </div>
                    <h2 className="about-block-title">{t("about.tire")}</h2>
                    <div className="about-cards-container">
                        <div className="about-card">
                            <img
                                src={introImage}
                                alt="Équipe Passionnée"
                                className="card-image"
                            />
                            <p className="card-text">
                                {t("about.description")}
                            </p>
                        </div>
                        <div className="about-card">
                            <img
                                src={passionImage}
                                alt="Menus Gourmets"
                                className="card-image"
                            />
                            <p className="card-text">{t("about.menu")}</p>
                        </div>
                        <div className="about-card">
                            <img
                                src={qualityImage}
                                alt="Qualité Élevée"
                                className="card-image"
                            />
                            <p className="card-text">{t("about.norme")}</p>
                        </div>
                    </div>
                    <h3 className="gallery-title">{t("about.galerie")}</h3>
                    <div className="main-gallery-wrapper">
                        <button
                            className="gallery-nav prev"
                            onClick={prevImage}
                        >
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </button>
                        <div className="main-gallery-image">
                            <img
                                src={galleryImages[currentImageIndex]}
                                alt={`Galerie Image ${currentImageIndex + 1}`}
                            />
                        </div>
                        <button
                            className="gallery-nav next"
                            onClick={nextImage}
                        >
                            <FontAwesomeIcon icon={faChevronRight} />
                        </button>
                    </div>
                    <div className="thumbnail-gallery" ref={galleryRef}>
                        {galleryImages.map((image, index) => (
                            <img
                                key={index}
                                src={image}
                                alt={`Miniature ${index + 1}`}
                                className={`thumbnail-image ${
                                    index === currentImageIndex ? "active" : ""
                                }`}
                                style={{
                                    transform: `scale(${
                                        index === currentImageIndex ? 1.2 : 1
                                    })`,
                                    opacity:
                                        index === currentImageIndex ? 1 : 0.7,
                                }}
                                onClick={() => handleThumbnailClick(index)}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
